// Animation tokens, lifted from the moodboard repo. Same curve names so the polish
// reads the same to anyone familiar with both codebases. See ../../../../../moodboard
// for the original docs on when each curve should fire.

// "Snap with anticipation" — for item spawn, drop-into-place. Slight overshoot.
export const SNAP_CURVE = [0.7, -0.05, 0.2, 1.05] as const

// Standard ease-out — for panels appearing, anything that should land calmly.
export const EASE_OUT_STANDARD = [0.2, 0.8, 0.2, 1] as const

// Quick ease-out — for follow-up updates after the first appear.
export const EASE_OUT_QUICK = [0.3, 0, 0.2, 1] as const

// Springy physics — reserved for moments that need real weight (rare).
export const SNAP_SPRING = {
  type: 'spring' as const,
  stiffness: 700,
  damping: 22,
  mass: 0.6,
}

// Don't tween: selection, hover, drag-follow, wheel zoom. Those must be 1:1 with input,
// otherwise the canvas feels laggy rather than smooth.
